import React from "react";
import styles from "./index.module.css";

const HowToGetStartedSection = () => {
  return (
    <div className={styles.mainDiv}>
      <div className={styles.innerDiv}>
        <div className={styles.headerRow}>
          <h2 className={styles.title}>How to get started</h2>
          <p className={styles.supportText}>
            Need support? <a href="/contact">Talk to our team</a>
          </p>
        </div>
        <div className={styles.cardsGrid}>
          <div className={styles.card}>
            <div className={styles.stepBadge}>1</div>
            <h3 className={styles.cardTitle}>Sign up in minutes</h3>
            <p className={styles.cardDescription}>
            Contact our sales team and we'll create your account, configure your POS system, 
            and deliver your business credentials within minutes.
            </p>
          </div>

          <div className={styles.card}>
            <div className={styles.stepBadge}>2</div>
            <h3 className={styles.cardTitle}>Install the Epinics POS software</h3>
            <p className={styles.cardDescription}>
            Download and install the Epinics POS software on your computer, 
            then log in using the business credentials provided during setup.
            </p>
          </div>

          <div className={styles.card}>
            <div className={styles.stepBadge}>3</div>
            <h3 className={styles.cardTitle}>Start selling</h3>
            <p className={styles.cardDescription}>
              Reach customers in store and track every
              sale from your our POS system.
            </p>
            <a className={styles.startBtn} href="https://onboard.epinics.com/" target="_blank" rel="noopener noreferrer">
              Get started
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowToGetStartedSection;
